import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createRcsPrintViewModelV2 } from "./createRcsPrintViewModelV2";

const rcsStylesV2 = `
  ${officialDocumentStyles}
`;

const renderRcsBody = (model, t) => `
  <main class="official-document">
    <header class="official-header">
      <div class="official-logo-wrap">
        ${
          model.companyLogo
            ? `<img src="${escapeHtml(model.companyLogo)}" alt="Company logo" class="official-logo" />`
            : ""
        }
      </div>
      <div class="official-header-main">
        <h1 class="official-vessel-name">${escapeHtml(model.vesselName)}</h1>
        <h2 class="official-title">${escapeHtml(model.title)}</h2>
      </div>
    </header>

    <hr class="official-rule" />

    <table class="official-meta" aria-label="Document metadata">
      <tbody>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("forPrint.toShippers"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.toShippers)}</td>
          <td class="official-meta-label">${escapeHtml(t("forPrint.port"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.port)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">Voyage No.:</td>
          <td class="official-meta-value">${escapeHtml(model.voyageNumber)}</td>
          <td class="official-meta-label">${escapeHtml(t("forPrint.from"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.fromPort)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("forPrint.to"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.toPort)}</td>
          <td class="official-meta-label">${escapeHtml(t("forPrint.grade"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.cargoName)}</td>
        </tr>
      </tbody>
    </table>

    <hr class="official-meta-separator" />

    <section class="official-section">
      <p class="official-paragraph">${escapeHtml(model.note)}</p>
      <p class="official-paragraph">
        <span class="official-emphasis">${escapeHtml(t("forPrint.grade"))}:</span>
        ${escapeHtml(model.cargoName)}
      </p>
      <p class="official-paragraph">
        <span class="official-emphasis">${escapeHtml(t("voyageInfo.rate"))}:</span>
        ${escapeHtml(model.inputRate)}
      </p>
    </section>

    <section class="official-receipt">
      <div class="official-receipt-grid">
        <span class="official-receipt-label">${escapeHtml(t("forPrint.received"))}:</span>
        <span class="official-line"></span>
      </div>
      <div class="official-receipt-row-secondary">
        <span class="official-receipt-label">${escapeHtml(t("forPrint.date"))}:</span>
        <span class="official-line"></span>
        <span class="official-receipt-label">${escapeHtml(t("forPrint.time"))}:</span>
        <span class="official-line"></span>
      </div>
    </section>

    <section class="official-section">
      <p class="official-paragraph">${escapeHtml(model.protestText)}</p>
      <div class="official-receipt-grid">
        <span class="official-receipt-label">${escapeHtml(model.actualRateLabel)}</span>
        <span class="official-line"></span>
      </div>
      <div class="official-receipt-grid">
        <span class="official-receipt-label">${escapeHtml(t("forPrint.date"))}:</span>
        <span class="official-line"></span>
      </div>
      <p class="official-paragraph">
        <span class="official-emphasis">${escapeHtml(model.loadingMasterLabel)}:</span>
      </p>
      <p class="official-note">${escapeHtml(model.commentsLabel)}</p>
    </section>

    <section class="official-signatures">
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">
          <div>${escapeHtml(t("forPrint.chiefOfficer"))}</div>
          <div class="official-signature-name">${escapeHtml(model.chiefOfficer)}</div>
        </div>
      </div>
      <div class="official-signature-block">
        <div class="official-signature-line"></div>
        <div class="official-signature-caption">${escapeHtml(model.loadingMasterLabel)}</div>
      </div>
    </section>
  </main>
`;

export const renderRcsV2 = (input) => {
  const model = createRcsPrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: "rcs",
    viewModel: model,
    styles: rcsStylesV2,
    body: renderRcsBody(model, input.t),
  });
};
